import { DEFAULT_ROWS_PER_PAGE } from '@crema/constants';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';
import { axiosBaseQuery } from './baseQuery';

const CHANNEL_COMMON_INFO_URL = `/api/channel-common-info`;

export const channelCommonInfoApi = createApi({
  reducerPath: 'channelCommonInfo.api',
  baseQuery: axiosBaseQuery,
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  tagTypes: ['channelCommonInfo'],
  endpoints: (builder) => ({
    getChannelCommonInfos: builder.query({
      query: ({ pageNo = 0, pageSize = DEFAULT_ROWS_PER_PAGE, name = '', type = '' }) => ({
        url: `${CHANNEL_COMMON_INFO_URL}?pageNo=${pageNo}&pageSize=${pageSize}${name != '' ? `&name=${name}` : ''}${type != 'all' ? `&type=${type}` : ''}`,
      }),
      transformResponse: (response, meta: any) => {
        return {
          rows: response,
          totalCount: meta.totalCount,
        };
      },
      providesTags: ['channelCommonInfo'],
    }),
    getChannelCommonInfoById: builder.query({
      query: (id) => ({ url: `${CHANNEL_COMMON_INFO_URL}/${id}` }),
      providesTags: ['channelCommonInfo'],
    }),
    addChannelCommonInfo: builder.mutation({
      query: (body) => ({
        url: `${CHANNEL_COMMON_INFO_URL}`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['channelCommonInfo'],
    }),
    deleteChannelCommonInfo: builder.mutation({
      query: (id) => ({
        url: `${CHANNEL_COMMON_INFO_URL}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['channelCommonInfo'],
    }),
    updateChannelCommonInfo: builder.mutation({
      query: (data) => ({
        url: `${CHANNEL_COMMON_INFO_URL}/${data.id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['channelCommonInfo'],
    }),
  }),
});

export const {
  useGetChannelCommonInfosQuery,
  useGetChannelCommonInfoByIdQuery,
  useAddChannelCommonInfoMutation,
  useDeleteChannelCommonInfoMutation,
  useUpdateChannelCommonInfoMutation,
} = channelCommonInfoApi;
